(ns pfo.collection.core
  (:require [secretary.core :as secretary :refer-macros [defroute]]
            [promesa.core :as p]
            [reagent.session :as session]
            [pfo.util :as util]
            [pfo.common.component :refer [empty-page]]
            [pfo.collection.component :as component]
            [pfo.state :as state]
            [pfo.api :refer [process-error]]
            [pfo.collection.model :as model]
            [pfo.widget.orgchart :refer [org-chart]]))

(defn about-page []
  [:div [:h2 "About pfo"]
   [:div [:a {:href "#/"} "go to the home page"]]])

(defn collection-details [{:keys [id]}]
  (when (not= @state/last-collection-details-id id)
    (reset! state/ui-state {}))
  (reset! state/last-collection-details-id id)
  (->> (p/all [(model/collection-full-details id)
               (model/collection-ancestors id)
               (model/permitted-users nil id)])
       (p/map (fn [[details-response ancestors-response users-response]]
                ;; store ancestor ids in global state to allow opening nav
                ;; panel to most recently viewed collection
                (reset! state/recent-parent-ids (concat [nil] (mapv #(:id %) (filterv :has_any_permission ancestors-response))))
                (util/set-page (partial component/collection-details details-response ancestors-response users-response))))
       (process-error))
  (util/set-initial-page empty-page))

(defn collection-boir-preview [type {:keys [id]}]
  (->>
    (p/all [(model/collection-full-details id)
            (model/collection-ancestors id)])
    (p/map
      (fn [[collection ancestor-list]]
        (util/set-page (partial component/boir-preview-standalone type collection ancestor-list))))
    (process-error))
  (util/set-initial-page empty-page))

(defn collection-boir-pdf-preview [params]
  (collection-boir-preview :pdf params))

(defn collection-boir-efile-preview [params]
  (collection-boir-preview :efile params))

(defn collection-charts [{:keys [id]}]
  (util/set-page (partial org-chart id)))
